import { useState, useEffect, useMemo } from 'react';
import { getAllProductsWithNames, getCompetenceTable } from '../../../api/configuracionSku';

export const useConfiguracionSku = () => {
  const [skusData, setSkusData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [competenciasAsignadas, setCompetenciasAsignadas] = useState({});
  const [cargandoCompetencias, setCargandoCompetencias] = useState(false);

  // Función para obtener todos los SKUs desde la API
  const fetchSkus = async () => {
    try {
      console.log('Intentando cargar productos desde la API...');
      const response = await getAllProductsWithNames();
      console.log('Datos de productos recibidos:', response.data);
      
      // Normalizar los datos para asegurar que los campos estén disponibles
      const productos = response.data.data || response.data;
      
      // Log para verificar el primer producto
      if (productos && productos.length > 0) {
        console.log('📊 Primer producto - Columnas disponibles:', Object.keys(productos[0]));
        console.log('📊 Primer producto completo:', productos[0]);
      }
      
      setSkusData(productos);
    } catch (err) {
      console.error('Error al cargar SKUs:', err);
      setError('Error al cargar los SKUs: ' + err.message);
    }
  };

  // Función para obtener todas las competencias asignadas
  const obtenerTodasLasCompetenciasAsignadas = async () => {
    try {
      console.log('Obteniendo todas las competencias asignadas...');
      
      const response = await getCompetenceTable();
      console.log('Todas las competencias obtenidas:', response.data);
      
      // Organizar competencias por ID_PRODUCT
      const competenciasPorProducto = {};
      response.data.data.forEach(comp => {
        const productoId = comp.ID_PRODUCT;
        if (!competenciasPorProducto[productoId]) {
          competenciasPorProducto[productoId] = [];
        }
        competenciasPorProducto[productoId].push(comp);
      });
      
      console.log('Competencias organizadas por producto:', competenciasPorProducto);
      return competenciasPorProducto;
    } catch (error) {
      console.error('Error al obtener competencias asignadas:', error);
      return {};
    }
  };

  // Cargar datos al montar el componente
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      setError(null);
      
      try {
        // Intentar cargar productos
        try {
          await fetchSkus();
        } catch (productError) {
          console.warn('No se pudieron cargar los productos:', productError);
        }
        
        // Cargar competencias asignadas
        try {
          setCargandoCompetencias(true);
          const competenciasPorProducto = await obtenerTodasLasCompetenciasAsignadas();
          setCompetenciasAsignadas(competenciasPorProducto);
        } catch (competenceError) {
          console.warn('No se pudieron cargar las competencias asignadas:', competenceError);
        } finally {
          setCargandoCompetencias(false);
        }
      } catch (err) {
        console.error('Error al cargar datos:', err);
        setError('Error al cargar los datos');
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  // Crear clientes basándose en los ID_CLIENT únicos de la tabla products
  const clientesConProductos = useMemo(() => {
    if (!skusData || skusData.length === 0) return [];
    
    // Obtener IDs únicos de clientes que tienen productos
    const idsClientesConProductos = [...new Set(skusData.map(sku => sku.ID_CLIENT))];
    console.log('IDs de clientes con productos:', idsClientesConProductos);
    
    // Crear clientes basándose en ID_CLIENT con nombres reales
    const clientes = idsClientesConProductos.map(idCliente => {
      const productosDelCliente = skusData.filter(sku => sku.ID_CLIENT === idCliente);
      const primerProducto = productosDelCliente[0];
      
      return {
        id: idCliente.toString(),
        nombre_cliente: primerProducto.client_name || `Cliente ${idCliente}`,
        descripcion: `Cliente con ${productosDelCliente.length} productos`,
        estatus: "activo",
        cod_cliente: idCliente,
        rif: `ID-${idCliente}`,
        establecimientos: []
      };
    });
    
    return clientes;
  }, [skusData]);

  return {
    skusData,
    loading,
    error,
    competenciasAsignadas,
    cargandoCompetencias,
    clientesConProductos,
    fetchSkus,
    obtenerTodasLasCompetenciasAsignadas,
    setCompetenciasAsignadas,
    setCargandoCompetencias
  };
};
